import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PatientPort } from '@service/preclinical/patient.port';
import { PatientService } from '@infra-services/patients/patient.service';
import { PatientSearchResult } from '@model/patient/patient.model';
import {
  ManualEntryPayload,
  ManualEntryResponse,
  ReprocessPayload
} from '@model/patient/sample-entry.model';

@Injectable({
  providedIn: 'root'
})
export class PatientAdapter implements PatientPort {
  private readonly patientService = inject(PatientService);

  searchPatient(params: {
    identifierType: string;
    idNumber: string;
  }): Observable<PatientSearchResult> {
    return this.patientService.searchPatient(params);
  }

  searchByCode(specimenCode: string): Observable<PatientSearchResult> {
    return this.patientService.searchByCode(specimenCode);
  }

  saveSampleByCode(caseNumber: string, payload: any): Observable<any> {
    return this.patientService.saveSampleByCode(caseNumber, payload);
  }

  saveManualSample(
    payload: ManualEntryPayload
  ): Observable<ManualEntryResponse> {
    return this.patientService.saveManualSample(payload);
  }

  getSampleByCaseNumber(caseNumber: string): Observable<ManualEntryPayload> {
    return this.patientService.getSampleByCaseNumber(caseNumber);
  }

  updateSample(
    caseNumber: string,
    payload: ManualEntryPayload
  ): Observable<any> {
    return this.patientService.updateSample(caseNumber, payload);
  }

  deleteSample(specimenCode: string): Observable<void> {
    return this.patientService.deleteSample(specimenCode);
  }

  saveReprocess(
    specimenCode: string,
    payload: ReprocessPayload
  ): Observable<void> {
    return this.patientService.saveReprocess(specimenCode, payload);
  }

  getSpecimenTypes(): Observable<{ id: string; name: string }[]> {
    return this.patientService.getSpecimenTypes();
  }
}
